import { SimpleDocCommand } from '../DocsApp/commands/v5/types';
import { CommandExecutionContext } from '../../types/commands';
import { StandardToolResult } from '../../types/standardToolResults';
import fetchService from '../../services/fetchService';
import { API_BASE_URL } from '../../api/config';
import { MANIFEST } from './slack_send_dm.m';
import { schemaToParameters } from '../../utils/schemaToParameters';

const log = { log: (...a: any[]) => console.log('[SLACK_QUERY_TOOL]', ...a) };

export const slack_send_dm: SimpleDocCommand = {
  id: MANIFEST.name,
  logicalName: 'slack_send_dm',
  version: 'v1',
  description: MANIFEST.description,

  schema: {
    parameters: schemaToParameters(MANIFEST.inputSchema),
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { slackUserId, text, workspaceId } = params;

    if (!slackUserId?.trim()) {
      return { status: 'error', message: 'slackUserId is required', format: 'plaintext' };
    }
    if (!text?.trim()) {
      return { status: 'error', message: 'text is required', format: 'plaintext' };
    }

    try {
      const data = await fetchService(`${API_BASE_URL}/integrations/slack/send-dm`, {
        method: 'POST',
        body: JSON.stringify({ slackUserId, text, workspaceId }),
      });

      if (data.error || data.detail) {
        const detail = data.detail || data.error;
        return {
          status: 'error',
          message: detail.includes('not connected')
            ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
            : `Slack send-dm failed: ${detail}`,
          error: { code: 'send_dm_failed', category: 'execution', details: detail },
          format: 'plaintext',
        };
      }

      log.log(`send-dm: sent to ${slackUserId} ts=${data.ts}`);
      return {
        status: 'success',
        message: `Message sent to ${slackUserId}`,
        data: { ts: data.ts, tsIso: data.tsIso, channelId: data.channelId, workspaceId: data.workspaceId },
        format: 'json',
      };
    } catch (error: any) {
      const detail = error.data?.detail || error.message || 'Unknown error';
      return {
        status: 'error',
        message: detail.includes('not connected')
          ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
          : `Slack send-dm failed: ${detail}`,
        error: { code: 'error', category: error.status === 400 ? 'validation' : 'execution', details: detail },
        format: 'plaintext',
      };
    }
  },
};
